import React from 'react';
import {
	ArrayInput,
	DateInput,
	Edit,
	ReferenceArrayInput,
	SelectArrayInput,
	SimpleForm, SimpleFormIterator,
	TextInput, useRecordContext,
} from 'react-admin';
import CreateInDialogButton from '../components/dialogs/CreateInDialogButton';

const NEWS_STATUS_PREMODERATION = 'PREMODERATION';

export const CreateTradeUnionNewsButton = (props) => {
	const { children } = props;
	const record = useRecordContext();
	return (
		<CreateInDialogButton
			fullWidth
			record={{
				tradeUnion: { id: record.id },
				status: NEWS_STATUS_PREMODERATION,
				displayDate: new Date(),
			}}
			resource="TradeUnionNews"
		>
			{children}
		</CreateInDialogButton>
	);
};

export const CreateTadeUnionNewsForm = () => {
	return (
		<SimpleForm>
			<TextInput label="Заголовок" source="title" required fullWidth />
			<TextInput label="Текст" source="text" required multiline fullWidth />
			<DateInput label="Дата новости" source="displayDate" required />
			<ArrayInput label="Ссылки" source="links">
				<SimpleFormIterator>
					<TextInput label="Заголовок" source="title" />
					<TextInput label="Ссылка" source="url" />
				</SimpleFormIterator>
			</ArrayInput>
		</SimpleForm>
	);
};

const DownloadableOptionTextField = () => {
	const record = useRecordContext();
	const options = {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
	};
	return (
		`${record.id} ${new Intl.DateTimeFormat('ru', options).format(record.createdAt)}`
	);
};

export const EditTradeUnionNewsForm = () => {
	return (
		<SimpleForm>
			<TextInput label="Заголовок" source="title" fullWidth />
			<TextInput label="Текст" source="text" multiline fullWidth />
			<DateInput label="Дата новости" source="displayDate" />
			<ArrayInput label="Ссылки" source="links">
				<SimpleFormIterator>
					<TextInput label="Заголовок" source="title" />
					<TextInput label="Ссылка" source="url" />
				</SimpleFormIterator>
			</ArrayInput>
			<ReferenceArrayInput source="documents" reference="Downloadable">
				<SelectArrayInput
					optionValue="id"
					optionText={<DownloadableOptionTextField />}
					label="Документы"
				/>
			</ReferenceArrayInput>
		</SimpleForm>
	);
};

const EditTradeUnionNews = () => {
	return (
		<Edit>
			<SimpleForm>
				<TextInput label="Заголовок" source="title" fullWidth />
				<TextInput label="Текст" source="text" multiline fullWidth />
				<DateInput label="Дата новости" source="displayDate" />
				<ArrayInput label="Ссылки" source="links">
					<SimpleFormIterator>
						<TextInput label="Заголовок" source="title" />
						<TextInput label="Ссылка" source="url" />
					</SimpleFormIterator>
				</ArrayInput>
			</SimpleForm>
		</Edit>
	);
};

export default EditTradeUnionNews;
